<template>
  <div class="content main-container">
    <div class="info" ref="infoBox">
      <template v-if="userInfo.userType == 2">
        <p>说明：</p>
        <p>1、商户可在此页面查看业务员的最新提现申请和历史提现记录。</p>
        <p v-if="$units.isOkBao()">2、商户在此处审核业务员的提现申请，审核通过后，商户向业务员进行转账支付。</p>
        <p v-else>2、商户在此处审核业务员的提现申请，审核通过后，商户自行安排向业务员线下打款。</p>
      </template>
      <template v-if="userInfo.userType == 3"> 说明： 1、可在此页面查看本机构下业务员的最新提现申请和历史提现记录。 </template>
    </div>
    <div class="search-box btn3">
      <div class="input-item">
        <span class="label">业务员姓名/手机号</span>
        <Input v-model="searchParams.userNameOrPhone" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">申请时间</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          v-model="searchParams.date"
          format="yyyy-MM-dd"
          placeholder="选择日期"
        ></DatePicker>
      </div>
      <div class="input-item" v-if="$units.isOkBao()">
        <span class="label">结算主体</span>
        <Select v-model="searchParams.orgId" clearable filterable>
          <Option v-for="(item, i) in settlementEntityList" :key="i" :value="item.orgId" :label="item.settlementEntity"></Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="search">查询</Button>
        <Button v-if="$units.pointAction('offline_81_6_5')" type="warning" @click="downloadAll">批量下载资料</Button>
        <Button v-if="$units.pointAction('offline_81_6_6')" type="warning" @click="exportTableData">导出明细</Button>
      </div>
    </div>

    <Tabs v-model="status" @on-click="tabClick">
      <TabPane label="全部" name=" "></TabPane>
      <TabPane :label="$units.isOkBao() ? '待打款' : '申请中'" name="0"></TabPane>
      <TabPane label="银行处理中" name="9" v-if="$units.isOkBao()"></TabPane>
      <TabPane label="提现成功" name="1"></TabPane>
      <TabPane label="已驳回" name="2"></TabPane>
    </Tabs>
    <Tabs v-model="paymentType" @on-click="search" v-if="$units.isOkBao() && status == '0'" class="second-tabs">
      <TabPane label="在线打款" name="1"></TabPane>
      <TabPane label="线下打款" name="2"></TabPane>
    </Tabs>

    <div class="table-box">
      <loading :isShow="$root.$children[0].isShowLoading" />
      <div class="select-box">
        <Checkbox v-model="isAll" @on-change="changeIsAll">全选</Checkbox>
        <span>已选{{ selIds.length }}/{{ total }}项</span>
        <Button v-if="$units.pointAction('offline_81_6_4') && (status === '9' || status === '0')" type="warning" @click="auditAll">
          {{ $units.isOkBao() ? '批量操作' : '批量审核' }}
        </Button>
      </div>
      <Table
        :columns="columns"
        :data="tableData"
        ref="selection"
        @on-select-all-cancel="handleCancelSelectAll"
        @on-select-all="handleSelectAll"
        @on-select="handleSelect"
        @on-select-cancel="handleCancel"
      >
        <template slot-scope="{ row }" slot="userName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }"></i>
              <span class="user-name">{{ row.staffNo }}</span>
              <span v-if="row.staffNo">/</span>
              <span class="user-name">{{ row.userName }}</span>
            </div>
          </div>
        </template>
        <template slot-scope="{ row }" slot="resource">
          <div class="detail">
            <span class="table-btn" v-if="row.detail && (row.detail != '[]' || row.receipt)" @click="showResource(row)">查看</span>
            <span class="table-btn" v-if="row.detail && (row.detail != '[]' || row.receipt)" @click="loadDta(row.id)">下载</span>
            <span v-else>无</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="idNo">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-if="row.idNo">
            <span class="text" v-if="row.eyeShow1">{{ row.idNo1 }}</span>
            <span class="text" v-else>{{ row.idNo }}</span>
            <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow1" @click="openEye(row, 'eyeShow1', 'idNo')"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow1" @click="openEye(row, 'eyeShow1', 'idNo')"></i>
          </div>
        </template>
        <template slot-scope="{ row }" slot="cardNo">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-if="row.cardNo">
            <span class="text" v-if="row.eyeShow2">{{ row.cardNo1 }}</span>
            <span class="text" v-else>{{ row.cardNo }}</span>
            <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow2" @click="openEye(row, 'eyeShow2', 'cardNo')"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow2" @click="openEye(row, 'eyeShow2', 'cardNo')"></i>
          </div>
        </template>
        <template slot-scope="{ row }" slot="mobile">
          <div style="display: flex; align-items: center; white-space: nowrap; justify-content: center" v-if="row.mobile">
            <span class="text" v-if="row.eyeShow3">{{ row.mobile1 }}</span>
            <span class="text" v-else>{{ row.mobile }}</span>
            <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow3" @click="openEye(row, 'eyeShow3', 'mobile')"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow3" @click="openEye(row, 'eyeShow3', 'mobile')"></i>
          </div>
        </template>
        <template slot-scope="{ row }" slot="status">
          <div class="tag">
            <span v-if="row.status == '0'" class="item not-started">{{ $units.isOkBao() ? '待打款' : '申请中' }}</span>
            <span v-else-if="row.status == '9'" class="item processing">银行处理中</span>
            <span v-else-if="row.status == '1'" class="item success">提现成功</span>
            <span v-else-if="row.status == '-1'" class="item ended">转账失败</span>
            <span v-else-if="row.status == '2'" class="item ended">已驳回</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <!-- 转账失败 -->
          <div class="detail" v-if="row.status == '-1'">
            <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip left-10" transfer>
              <span class="table-btn red def">失败原因</span>
              <div slot="content">
                <p>{{ row.reason }}</p>
              </div>
            </Poptip>
            <span class="table-btn" @click="getDetailData(row)">重新付款</span>
          </div>
          <div class="detail" v-else>
            <span class="table-btn" @click="getDetailData(row)">详情</span>
            <span class="table-btn" @click="getDetail(row.userId, row.id)">明细</span>
          </div>
        </template>
      </Table>
      <div class="pageBox">
        <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center" />
      </div>
    </div>
    <!-- 详情  -->
    <Modal
      v-model="isShowDetail"
      :title="$units.isOkBao() ? '详情' : '审核详情'"
      @on-ok="confirmDetail"
      :loading="$root.$children[0].modalLoading"
      @on-cancel="cancelDetail"
      width="1200"
      :footer-hide="detailInfo.status == 0 || detailInfo.status == -1 ? false : true"
      class="my-modal top"
    >
      <div slot="footer">
        <Button type="primary" @click="confirm(2)" ghost>驳回</Button>
        <Button type="primary" @click="confirm(1)" v-if="detailInfo.status == -1">重新打款</Button>
        <Button type="primary" @click="confirm(1)" v-if="detailInfo.status == 0">{{ $units.isOkBao() ? '打款' : '审核通过' }}</Button>
      </div>
      <loading :isShow="loading" />
      <myForm :formList="detailList" ref="form" :md="12" />
    </Modal>
    <Modal v-model="isShowDate" title="打款时间" :mask-closable="false" :footer-hide="true" width="500px" class="my-modal top">
      <div class="confirm-box" style="margin-top: 20px">
        <span style="margin-right: 10px">打款时间</span>
        <DatePicker type="date" transfer v-model.trim="paymentTime" format="yyyy-MM-dd" placeholder="选择日期"></DatePicker>
      </div>
      <div class="ivu-modal-footer">
        <Button type="text" @click="cancelDate">取消</Button>
        <Button type="primary" @click="confirmPass">确定</Button>
      </div>
    </Modal>

    <Modal v-model="showImg" title="提现资料查看" width="800" :footer-hide="true" class="my-modal top">
      <Form ref="form" :model="salesForm" :label-width="100" class="modal-form" v-if="showImg" label-position="left">
        <FormItem prop="userName" label="业务员姓名">
          <span>{{ salesForm.userName }}</span>
        </FormItem>
        <FormItem prop="requestAmount" label="申请金额">
          <span>{{ salesForm.requestAmount }}</span>
        </FormItem>
        <FormItem prop="requestTime" label="申请时间">
          <span>{{ salesForm.requestTime | filterTime('YYYY-MM-DD HH:mm') }}</span>
        </FormItem>
        <FormItem prop="requestTime" label="发票" class="full">
          <resource ref="resourceRef" :urlList="urlList" width="100px" height="100px"></resource>
        </FormItem>
      </Form>
    </Modal>
    <withdrawalLot ref="withdrawalLot"></withdrawalLot>
    <auditModal ref="auditModalRef" @success="search" />
    <!-- ok保提现验证 -->
    <okbao-check ref="okbaoCheck" @reload="search()"></okbao-check>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import filter from '@/api/filter';
import detail from './form/detail';
import myForm from '@/components/commons/form';
import auditModal from './components/auditModal.vue';
import resource from '@/components/commons/resource';
import withdrawalLot from './components/withdrawalLot.vue';
import okbaoCheck from './components/okbaoCheck.vue';
import { serverWithdrawLogDetail, userCashWithdrawAudit } from '@/api/httpList';
import confirmModal from '@/components/commons/confirmModal';
import { pageTool, common } from '@/api/mixins';
import { config } from './index.config.js';

export default {
  mixins: [config, pageTool, common],
  components: {
    myForm,
    confirmModal,
    resource,
    okbaoCheck,
    withdrawalLot,
    auditModal,
  },
  props: {},
  data() {
    return {
      searchParams: {
        date: [],
      },
      settlementEntityList: [],// 结算主体
      status: '0',
      paymentType: '1',//1线上打款（提现金额≤19999元） 2线下打款（提现金额＞19999元）
      salesForm: {},
      showImg: false,
      urlList: [],
      allTableIds: [], // 所有的id
      allTableData: [], // 所有的数据
      selIds: [], //选择项
      isAll: false, //是否全选
      paymentTime: '',
      isShowDate: false,
      detailInfo: {},
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      detailList: [],
      isShowDetail: false,
      loading: false,
      columns: []
    };
  },
  watch: {},
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    openEye(item,keyName,name){
      let operationType
      if(name == 'idNo'){
        operationType = 1
      }else if(name == 'mobile'){
        operationType = 2
      }else if(name == 'cardNo'){
        operationType = 3
      }
      if (!item[keyName]) {
        this.descrypt(
          {
            query: item.id,
            operationFunction: 23,
            operationType: operationType
          },
          item,
          name + '1',
        ).then(() => {
          this.$set(item, keyName, true);
        });
      } else {
        this.$set(item, keyName, false);
      }
    },
    // tab点击
    tabClick() {
      this.$units.cancelhttpRequest();
      this.paymentType = '1';
      this.getColumns();
      this.search();
    },
    auditAll() {
      if (this.selIds.length == 0) {
        return this.$notice.error('您还没有选择审核的数据');
      }
      const params = this.getParams();
      params.idList = this.selIds;
      params.searchStatus = this.status;
      delete params.status;
      this.$refs.auditModalRef.open(params, this.allTableData);
    },
    changeIsAll(val) {
      this.$refs.selection.selectAll(val);
      this.selIds = val ? JSON.parse(JSON.stringify(this.allTableIds)) : [];
      this.isAll = this.selIds.length === this.allTableIds.length && this.allTableIds.length != 0;
    },
    // 取消全选
    handleCancelSelectAll(selection) {
      //从已选项中移除当页数据
      this.selIds = _.differenceBy(
        this.selIds,
        this.tableData.map(i => i.id)
      );
      this.isAll = this.selIds.length === this.allTableIds.length && this.allTableIds.length != 0;
    },
    // 全选
    handleSelectAll(selection) {
      //数组合并，有可能用户先选择了某几项，已经被我们push进去，因此数组合并需要去重一下
      let curSelIds = selection.map(i => i.id);
      this.selIds = _.uniqBy(this.selIds.concat(curSelIds));
      this.isAll = this.selIds.length === this.allTableIds.length && this.allTableIds.length != 0;
    },
    //选中单项
    handleSelect(selection, row) {
      //添加到已选项
      this.selIds.push(row.id);
      this.isAll = this.selIds.length === this.allTableIds.length && this.allTableIds.length != 0;
    },
    //取消选中单项
    handleCancel(selection, row) {
      //从已选项中去除取消项
      this.selIds = this.selIds.filter(id => {
        return id != row.id;
      });
      _.remove(this.selIds, n => {
        return n === row.id;
      });
      this.isAll = this.selIds.length === this.allTableIds.length && this.allTableIds.length != 0;
    },
    getDetailData(row) {
      this.isShowDetail = true;
      this.lookDetail(row);
    },
    getDetail(item1, item2) {
      this.$refs.withdrawalLot.open(item1, item2);
    },
    cancelDate() {
      this.paymentTime = '';
      this.isShowDate = false;
    },
    confirmPass() {
      if (this.paymentTime) {
        this.paymentTime = filter.filterTime(this.paymentTime, 'YYYY-MM-DD');
        this.isShowDate = false;
        this.userCashWithdraw(1);
      } else {
        this.$notice.msg('请选择打款日期');
      }
    },
    //审核
    confirm(type) {
      if (!this.$units.pointAction('offline_81_6_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (type == 1) {
        if (this.$units.isOkBao()) {
          if (this.detailInfo.requestAmount * 1 > 19999) {
            this.$notice.msg('业务员单次提现已超过19999元，请确认后进行线下打款，打款后通知相应研发更新打款状态');
            return;
          }
          this.isShowDetail = false;
          this.$refs.okbaoCheck.open({
            idList: [this.detailInfo.id],
            checkStatus: 1,
            requestTime: '',
            userNameOrPhone: ''
          });
        } else {
          this.isShowDetail = false;
          this.isShowDate = true;
        }
      } else {
        this.$refs.confirmModal
          .open({
            title: '提示',
            content: '确定驳回？'
          })
          .then(() => {
            this.userCashWithdraw(2);
          });
      }
    },
    async userCashWithdraw(type) {
      let remark = '';
      this.detailList[3].data.forEach(item => {
        if (item.key == 'remark') {
          remark = item.value;
        }
      });
      await userCashWithdrawAudit({
        id: this.detailInfo.id,
        status: type,
        paymentTime: this.paymentTime,
        remark
      });
      this.$Message.success('修改成功');
      this.getList();
      this.isShowDetail = false;
    },
    async lookDetail(row) {
      this.isShowDetail = true;
      this.loading = true;
      const res = await serverWithdrawLogDetail(row.id);
      let detailList = detail(this,false,row);
      this.detailInfo = res.data;
      for (let i = 0; i <= 3; i++) {
        detailList[i].data.forEach(item => {
          for (let key in res.data) {
            if (item.key == key) {
              item.value = res.data[key];
            }
            // 没收据时隐藏
            if (item.key == 'receipt' && (!this.$units.isOkBao() || !this.detailInfo.receipt)) {
              item.hidden = true;
              item.block = false;
            }
            if (this.$units.isOkBao()) {
              if(item.key == 'transNo' && this.detailInfo.status == 1) {
                item.hidden = false;
              }
              // 没发票时隐藏
              if(item.key == 'detail' && (this.detailInfo.detail == '[]' || !this.detailInfo.detail)){
                item.hidden = true;
                item.block = false;
              }
            }
            if (item.key == 'remark') {
              if (this.detailInfo.status == 0 || this.detailInfo.status == -1) {
                item.readonly = false;
              } else {
                item.readonly = true;
              }
            }
          }
        });
      }
      // ok保没发票且没收据时隐藏提现资料
      if(this.$units.isOkBao() && (this.detailInfo.detail == '[]' || !this.detailInfo.detail) && !this.detailInfo.receipt){
        // detailList = detailList.filter(item=>item.id != 'txzl')
        detailList.forEach(item=>{
          if(item.id == 'txzl'){
            item.hidden = true;
          }
        })
      }
      this.detailList = detailList;
      this.loading = false;
    },
    confirmDetail() {},
    cancelDetail() {},
    async getAllList() {
      const params = this.getParams();
      params.pageNo = 1;
      params.pageSize = 99999;
      try {
        const res = await this.$http({
          url: '/buz/userCashWithdrawLog/read/list',
          type: 'POST',
          data: params
        });
        this.allTableData = res.data;
        this.allTableIds = res.data.map(i => i.id);
      } catch (e) {}
    },
    //列表
    async getList() {
      const params = this.getParams();
      params.pageNo = this.pageNo;
      params.pageSize = this.pageSize;
      try {
        this.$root.$children[0].isShowLoading = true;
        const res = await this.$http({
          url: '/buz/userCashWithdrawLog/read/list',
          type: 'POST',
          data: params,
          apiPermissionCode: 'financialSh_3_0'
        });
        res.data.forEach(item => {
          if (this.isAll || this.selIds.includes(item.id)) {
            item._checked = true;
          }
        });
        this.tableData = res.data;
        this.$root.$children[0].isShowLoading = false;
        this.total = res.total;
      } catch (e) {
        this.$root.$children[0].isShowLoading = false;
      }
    },
    search() {
      this.isAll = false;
      this.selIds = [];
      this.pageNo = 1;
      this.getAllList();
      this.getList();
    },
    //批量下载
    async downloadAll() {
      if (this.selIds.length == 0) {
        return this.$notice.error('您还没有选择需要下载的数据');
      }
      let params = { idList: this.selIds };
      await this.$units.downloadFile('/buz/userCashWithdrawLog/batchDownloadZip', params, 'POST');
    },
    // 获取查询参数
    getParams() {
      let params = JSON.parse(JSON.stringify(this.searchParams));
      if(params.date && params.date[0]) {
        params.startTime = params.date[0];
        params.endTime = params.date[1];
      }
      delete params.date;
      if (this.status == 9) {
        params.statusList = [-1, 9];
      } else {
        params.status = this.status;
      }
      if(this.$units.isOkBao() && params.status == '0') {
        params.paymentType = this.paymentType;
      }
      return params;
    },
    // 导出
    exportTableData() {
      let params = {};
      if(this.$units.isOkBao() && this.selIds && this.selIds.length) {
        params.ids = this.selIds;
      }else {
        params = this.getParams();
      }
      this.$units.downloadFile('/buz/userCashWithdrawLog/export', params, 'POST');
    },
    showResource(item) {
      let detail = JSON.parse(item.detail);
      if (item.receipt && detail.length == 0) {
        // window.open(item.receipt, '_blank');
        this.urlList = [{ path: item.receipt, fileName: item.receipt.split('/').pop() }];

        this.showImg = true;
        this.salesForm = item;
      } else if (detail.length > 0) {
        const list = JSON.parse(decodeURIComponent(item.detail));
        this.urlList = list.map((item, index) => {
          return { path: item.path, fileName: item.fileName };
        });
        this.showImg = true;
        this.salesForm = item;
      }
    },
    async loadDta(id) {
      if (!this.$units.pointAction('offline_81_6_3')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      await this.$units.downloadFile('/buz/userCashWithdrawLog/downloadZip', { id: id });
      this.$Message.success('导出成功');
    },
    //分页切换页码
    pageChange(pageNo) {
      this.$root.$children[0].isShowLoading = true;
      this.pageNo = pageNo;
      this.getList();
    },
    // 获取结算主体
    queryOkSettlementEntity() {
      this.$http({
        url: '/buz/userCashWithdrawLog/queryOkSettlementEntity',
        type: 'GET',
        data: {}
      }).then(res => {
        if (res.data) {
          this.settlementEntityList = res.data;
        }
      });
    },
  },
  created() {},
  mounted() {
    if (this.userInfo.userType == 2) {
      //商户
    } else if (this.userInfo.userType == 3) {
      //下级机构
      this.columns.pop();
    }
    if(this.$units.isOkBao()) {
      this.queryOkSettlementEntity();
    }
  },
  activated(){
    this.getAllList();
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.info {
  margin-bottom: 15px;
  color: #727c8e;
  line-height: 1.8;
  overflow: hidden;
  position: relative;
}
/deep/ .action-columns .ivu-table-cell {
  padding: 0;
}
/deep/ .ivu-modal-body .ivu-col {
  width: 33.3%;
}

/deep/ .searchBox .ivu-col {
  .formItem {
    display: flex;
  }

  .ivu-form-item-content {
    margin-left: 0 !important;
    flex: 1;
  }

  width: 350px;

  .ivu-form-item-label {
    width: auto !important;
  }
}

.pageBox {
  margin: 30px 0;
}

/deep/ .beizhu {
  > div {
    margin-left: 0 !important;
  }
}

.content {
  .top {
    padding-bottom: 15px;
  }

  .block {
    float: left;
    width: 300px;

    .tx {
      float: left;
      text-align: center;

      > div:nth-child(2) {
        font-size: 16px;
        font-weight: bold;
      }
    }

    button {
      margin-left: 40px;
    }
  }

  .inner {
    background: #fff;
  }

  /deep/ .formGroup {
    padding: 0;
  }

  .searchBox {
    position: relative;
    margin-bottom: 5px;

    .toggleHeight {
      position: absolute;
      bottom: -20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 100;
    }

    /deep/ .ivu-input-group {
      z-index: 0;
    }

    /deep/ .ivu-form .ivu-form-item-label {
      text-align: left;
    }

    /deep/ .ivu-form-item-content {
      margin-right: 30px;
    }

    .left {
      float: left;
      width: calc(100vw - 300px) !important;
      // overflow: hidden;
    }

    .right {
      position: absolute;
      right: 0;
      top: 0px;

      // width: 180px;
      /deep/ .ivu-btn {
        min-width: 80px;
        height: 30px;
      }
    }
  }
}
/deep/.pdf-box {
  display: inline-block;
  background-color: #fff;
  width: 100px;
  height: 100px;
  background: url(~@static/images/cc_pdf.png);
  background-size: 100%;
  background-position: 0;
  background-repeat: no-repeat;
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
.tag {
  width: 100%;
  display: flex;
  justify-content: center;
  .item {
    min-width: 70px;
    padding: 0 7px;
    height: 24px;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding-top: 1px;
  }
  .not-started {
    color: #238fff;
    background: #ebf5ff;
    border: 1px solid #b5daff;
  }
  .success {
    width: 72px;
    color: #35bf3f;
    background: #f6fcf4;
    border: 1px solid #abeaae;
  }
  .processing {
    color: #ff8900;
    background: #fff4e8;
    border: 1px solid #ffd4a5;
  }
  .ended {
    color: #e3461f;
    background: #fff5f2;
    border: 1px solid #ffc1b2;
  }
}
.select-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .ivu-btn {
    margin-left: auto;
  }
}
</style>